module.exports = __webpack_public_path__ + "static/media/promo.7a468e49.png";